<template>
	<div v-if="hasOfferItems" class="offer-item">
		<div class="offer-info">
			<div class="offer-name">{{ offer.name }}</div>
			<div class="offer-description">{{ offer.description }}</div>
		</div>
		<div class="offer-add-text">
			Choose item to add offer:
		</div>
		<menu-item-rows
			:items="getOfferItems(offer)"
			:afterClick="autoApplyOffer"/>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import MenuItemRows from '@/components/menu/common/MenuItemRows.vue';
	import offersMixin from '@Mixin/offersMixin';
	import itemMixin from '@Mixin/itemMixin';
	import { map } from 'lodash';

	export default {
		mixins: [offersMixin, itemMixin],
		props: {
			offer: {
				type: Object,
				default: {
					name: 'Unknown',
					description: '',
				}
			},
		},
		components: {
			'menu-item-rows': MenuItemRows,
		},
		data() {
			return {
			};
		},
		computed: {
			hasOfferItems() {
				const offerItems = this.getOfferItems(this.offer);
				return (offerItems.length > 0);
			}
		},
		methods: {
			autoApplyOffer() {
				const offer = this.offer;
				this.setApplyOffer(offer);
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.offer-item {
		.offer-name {
			margin-left: 1rem;

			color: $offerTextColor;

			font-weight: bold;
			text-align: center;
		}
	}
	.offer-add-text {
		margin-top: 0.5em;
		width: 100%;
		text-align: center;
		font-weight: bold;
	}
	@include mobile {
		.offer-item {
			display: flex;
			flex-direction: column;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/OfferCouponItem.vue